import { setDefaultOptions } from 'date-fns'
import { useState, useEffect } from 'react'
import { importDateLocale } from '../lib/date-fns'

export const useDateFnsLocaleLoader = (locale: string) => {
  const [isLocaleLoaded, setIsLocaleLoaded] = useState(false)

  useEffect(() => {
    setIsLocaleLoaded(false) // Reset state when locale changes
    importDateLocale(locale)
      .then(({ default: locale }) => {
        setDefaultOptions({ locale })
      })
      .finally(() => {
        setIsLocaleLoaded(true)
      })
  }, [locale]) // Dependency array ensures this runs only when `locale` changes

  return {
    isLocaleLoaded,
  }
}
